import React from "react";
import EbDialog from "./_shared/EbDialog";
import "../ExecutionBlueprintReview/InfoDialog.scss";

// ═════════════════════════════════════════════════════════════════════════════
// "Run the live review" — the explainer shown once, the first time the coach
// opens the live session. See `ebLiveReviewInfoSeen` on the screen itself.
//
// ⚠️ REBUILT ON `EbDialog` (2026-08-31). Props unchanged (`onClose` only).
// It and `ReviewInfoModal` were numerically identical dialogs maintained as two
// stylesheets under different class prefixes; both use the shared shell now and
// share one small stylesheet for the numbered list.
//
// ⚠️ THE CEO APP HAS ITS OWN VARIANT OF THIS DIALOG, AND THE TWO MUST NOT BE
// RE-SYNCED BY DIFF (2026-09-03). Every line below is addressed to the coach
// ("your solo review is done", "what you flagged", "confirm the CEO is with
// you"), and the CEO app was rendering this same file — so the CEO was being
// told to confirm their own presence and to talk through flags they never
// made. The CEO's rewrite lives at
// `10x-frontend/.../ExecutionBlueprintLiveReview/LiveReviewInfoModal.js` and
// deliberately diverges; see its header.
//
// ⚠️ THE STEPS ARE JSX FRAGMENTS, NOT STRINGS — they carry bolded phrases, so
// they cannot be keyed by their own text the way every other list in this
// feature is. Keyed by index instead, which is safe here for the one reason it
// is ever safe: the list is a frozen constant that never reorders.
// ═════════════════════════════════════════════════════════════════════════════

const STEPS = [
  <>
    Confirm the <strong>CEO</strong> and their leadership team are with you
  </>,
  <>
    Click any <strong>agenda item</strong> to jump to it in the blueprint
  </>,
  <>Talk through what you flagged and agree the change together</>,
  <>
    <strong>Continue to WIG Connections</strong> once you&apos;ve been through
    every agenda item
  </>,
];

const LiveReviewInfoModal = ({ onClose }) => (
  <EbDialog
    isOpen
    size="lg"
    // Neutral: this explains rather than asks, and a teal chip would give it
    // the weight of a decision.
    tone="neutral"
    title="Run the live review"
    subtitle="Run this with the CEO and their leadership team, in person or on a video call."
    onClose={onClose}
    actions={[
      { label: "Okay", variant: "primary", onClick: onClose, autoFocus: true },
    ]}
  >
    <p>
      Your solo review is done, so now you&apos;ll work through it together. The{" "}
      <strong>Meeting Agenda</strong> on the right is your running order — every
      item you marked to discuss, plus every comment you left. Click an item to
      bring it up in the blueprint beside it.
    </p>
    <p>
      Make sure the CEO is with you before you start, because once you begin you
      can&apos;t step back to the previous stage.
    </p>

    <ol className="info-steps">
      {STEPS.map((step, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <li key={index}>{step}</li>
      ))}
    </ol>
  </EbDialog>
);

export default LiveReviewInfoModal;
